module.exports = __webpack_public_path__ + "static/sketch-3-bccefb7c0ee13c743e369397491f8822.jpeg";